<template>
    <div id="timer" :class="timerClass">
        <div class="pause" v-if="isPaused">
            <span>paused</span>
        </div>
        <div class="pause" v-if="hasEnded">
            <span>ended</span>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 635 101" v-bind:svg-inline="''" v-bind:class="'waves waves--top'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="waves" d="M609.27 5C599.1-1 572-4.13 536 10.73c-11.92 4.92-28.77 16.83-48.21 21.47s-35.08 1.8-50.22.62C387.09 28.87 364.75 55.14 320.43 60 258.21 66.87 229 32 161.1 31.58c-16.07-.1-28 3-44 2.82-31.25-.31-54.11-4.87-86.76 3.36C11.52 42.49.44 46.6 0 50.32c-3.47 31.47 340.84 64.75 527 44.49 61.6-6.7 100.93-18.64 107.1-42.21 4.43-16.78-8.43-37.86-24.83-47.6z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 635 101" v-bind:svg-inline="''" v-bind:class="'waves waves--dark'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="waves" d="M609.27 5C599.1-1 572-4.13 536 10.73c-11.92 4.92-28.77 16.83-48.21 21.47s-35.08 1.8-50.22.62C387.09 28.87 364.75 55.14 320.43 60 258.21 66.87 229 32 161.1 31.58c-16.07-.1-28 3-44 2.82-31.25-.31-54.11-4.87-86.76 3.36C11.52 42.49.44 46.6 0 50.32c-3.47 31.47 340.84 64.75 527 44.49 61.6-6.7 100.93-18.64 107.1-42.21 4.43-16.78-8.43-37.86-24.83-47.6z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 635 101" v-bind:svg-inline="''" v-bind:class="'waves waves--light'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="waves" d="M609.27 5C599.1-1 572-4.13 536 10.73c-11.92 4.92-28.77 16.83-48.21 21.47s-35.08 1.8-50.22.62C387.09 28.87 364.75 55.14 320.43 60 258.21 66.87 229 32 161.1 31.58c-16.07-.1-28 3-44 2.82-31.25-.31-54.11-4.87-86.76 3.36C11.52 42.49.44 46.6 0 50.32c-3.47 31.47 340.84 64.75 527 44.49 61.6-6.7 100.93-18.64 107.1-42.21 4.43-16.78-8.43-37.86-24.83-47.6z"/></svg>
        <span class="timeLeft">{{ humanTime(timeLeft) }}</span>
        <div class="timeBar">
            <span class="timeBar__progress" :style="progressWidth"></span>
        </div>
        <span class="timeTotal">{{ humanTime(timeTotal) }}</span>
    </div>
</template>

<script>
// import timeup from "@/assets/justin_timeup.mp3";
import maddyTimeup from "@/assets/custom/maddy/Sounds/maddy-time-is-up.mp3";
import maddyTimeup2 from "@/assets/custom/maddy/Sounds/thats-looking-awesome-but-the-time-is-up.mp3";
import maddyTimeup3 from "@/assets/custom/maddy/Sounds/youre-out-of-time.mp3";

import _ from "lodash";

const initialState = {
    countdown: null,
    timeLeft: 0,
    timeTotal: 0,
    timerClass: null,
    sounds: {
        timeUp: [maddyTimeup, maddyTimeup2, maddyTimeup3],
    },
    isPaused: false,
    hasEnded: false,
};

export default {
    name: "EnterpriseTimer",
    data: () => initialState,
    methods: {
        start() {
            const vm = this;
            this.countdown = setInterval(() => {
                vm.timeLeft -= 1;
            }, 1000);
            this.isPaused = false;
            this.hasEnded = false;
        },
        cancel() {
            clearInterval(this.countdown);
        },
        pause() {
            clearInterval(this.countdown);
            this.isPaused = true;
        },
        end() {
            clearInterval(this.countdown);
            this.hasEnded = true;
        },
        reset() {
            this.$data = initialState;
        },
        addTime(seconds) {
            this.timeLeft += seconds;
            this.timeTotal += seconds;

            if (this.timeLeft > 10) {
                this.timerClass = "";
            }
        },
        playSound(sound) {
            if (sound) {
                const audio = new Audio(sound);
                audio.play();
            }
        },
        humanTime(seconds) {
            let secondsLeft = seconds % 60;
            let minutes = Math.floor(seconds / 60);

            if (secondsLeft < 10) {
                secondsLeft = `0${secondsLeft}`;
            }

            return `${minutes}:${secondsLeft}`;
        },
    },
    watch: {
        timeLeft: function(val) {
            if (val > 10) {
                this.timerClass = "";
            }

            switch (val) {
                case 10:
                    this.timerClass = "ending";
                    break;
                case 0:
                    this.end();
                    this.timerClass = "ended";
                    this.playSound(_.sample(this.sounds.timeUp));
                    break;
            }
        },
    },
    computed: {
        progressWidth() {
            return {
                width: (this.timeLeft / this.timeTotal) * 100 + "%",
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
    transition: transform 1.5s;
}
.v-enter, .v-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: translateY(-100%);
}

#timer {
    background-color: #112935;
    border-radius: 3px 5px 15px 3px;
    display: inline-flex;
    padding: 30px 50px;
    font-weight: bold;
    color: #ffffff;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    transition: all ease-in-out 200ms;
}

.pause {
    position: absolute;
    bottom: 18px;
    font-size: 12px;
    font-weight: 300;
}

.waves {
    position: absolute;
    z-index: 0;
    width: 1000px;
    transition: fill 1s ease-in-out;

    &--top {
        fill: #5bf4e4;
        transform: rotate(180deg) translateY(38%) translateX(-10%);
    }

    &--light {
        fill: #5bf4e4;
        transform: translateY(30%) translateX(5%);
    }

    &--dark {
        fill: #1fb9b3;
        transform: translateY(30%) translateX(10%);
    }
}

.timeLeft,
.timeTotal {
    z-index: 10;
}

.timeBar {
    z-index: 1;
    background: #4c4c4c;
    min-width: 180px;
    margin: 0 12px;
    display: flex;
    height: 12px;
    overflow: hidden;
    border-radius: 3px;

    &__progress {
        background: #1fb9b3;
        transition: all 1s linear;
        z-index: 1;
    }
}

#timer.ending .timeBar {
    &__progress {
        background: #f14e79;
    }
}

#timer.ended {
    .waves {
        &--top {
            fill: #f14e79;
        }

        &--light {
            fill: #f14e79;
            transform: translateY(30%) translateX(5%);
        }

        &--dark {
            fill: #ce2e59;
            transform: translateY(30%) translateX(10%);
        }
    }
}

@keyframes blink {
    0% {
        background: white;
    }

    50% {
        background: rgb(195, 250, 233);
    }
}
</style>
